import { Song } from 'services/store/songs/types';
import { ReleaseStatus } from 'services/store/distribution/types';
import { IBaseSong } from '../song';

export interface Artist {
  id: string;
  name: string;
}

export interface ReleaseGenre {
  id: string;
  name: string;
}

export enum ReleaseSongStatus {
  VALID = 'VALID',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
}

export type ReleaseSong = IBaseSong & {
  status: ReleaseSongStatus;
  metadata?: {
    composer: string | null;
    hasVocals: boolean | null;
    vocalsContent: string | null;
    language: string | null;
    vocalist: string | null;
    additionalArtists: string[];
    remixers: string[];
    producers: string[];
  };
};

export interface Release {
  id: string;
  title: string | null;
  artistName: string | null;
  status: ReleaseStatus;
  genre: ReleaseGenre | null;
  coverArtPath: string | null;
  songs: ReleaseSong[];
}

export interface ReleaseList {
  releases: Release[];
  songs: Record<string, Song>;
  areAllPagesLoaded: boolean;
}

export interface ReleasesStats {
  draft: number;
  pending: number;
  released: number;
  declined: number;
}
